export enum SideNavigationOpenState {
  Expanded = 'Expanded',
  Condensed = 'Condensed',
  Collapsed = 'Collapsed'
}
